import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, map, tap } from 'rxjs';

import { ApiResponseDto } from '@common/models/api-response.dto';
import { CurrentUserResponseDto } from '@common/models/current-user/current-user.dto';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private http = inject(HttpClient);

  private cacheDto: CurrentUserResponseDto | null = null;

  getMe(force = false): Observable<CurrentUserResponseDto | null> {
    if (!force && this.cacheDto) {
      return of(this.cacheDto);
    }

    return this.http
      .get<ApiResponseDto<CurrentUserResponseDto>>('/auth/me')
      .pipe(
        map((res) => res.data),
        tap((dto) => {
          this.cacheDto = dto;
          if (dto) {
            sessionStorage.setItem('currentUser', JSON.stringify(dto));
          } else {
            sessionStorage.removeItem('currentUser');
          }
        }),
      );
  }

  getSnapshot(): CurrentUserResponseDto | null {
    if (this.cacheDto) return this.cacheDto;

    const stored = sessionStorage.getItem('currentUser');
    return stored ? JSON.parse(stored) : null;
  }

  clear(): void {
    this.cacheDto = null;
    sessionStorage.removeItem('currentUser');
  }
}
